import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByDate',
  pure: true
})
export class OrderByDatePipe implements PipeTransform {
  transform(array: any[], property: string, order: 'asc' | 'desc' = 'asc'): any[] {
    if (!Array.isArray(array) || !property) {
      return array;
    }

    return [...array].sort((a, b) => {
      const dateA = new Date(a[property]).getTime();
      const dateB = new Date(b[property]).getTime();

      return order === 'asc' ? dateA - dateB : dateB - dateA;
    });
  }
}
